import { Component, OnInit } from '@angular/core';
import { Paso3 } from 'src/app/global/interfaces/paso-3';
import { GoogleTagManager } from 'src/app/global/providers/services/tag-manager/models/tag-manager.models';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';

@Component({
  selector: 'app-generacion-producto',
  templateUrl: './generacion.component.html',
  styleUrls: ['./generacion.component.scss']
})
export class GeneracionProductoComponent implements OnInit {
  formatFelicitaciones = true;
  carroOnExito = true;
  dataPaso3: Paso3;
  nombres: string;
  correo: string;
  loading: boolean;
  showAgenda = false;
  fechaEntrega: string;
  riesgoso: boolean;
  isPersonaNatural: boolean = this.localStorageService.getPaso1Login().currentIsPersonaNatural;

  products$ = this.carroService.products$;
  constructor(
    private carroService: CarroComprasService,
    private localStorageService: LocalStorageService,
    private productoService: vmProductosService,
    private tagM:TagManagerService
  ) {}

  async ngOnInit() {
    this.loading = true;
    this.carroService.changePaso('RESUMEN');
    this.dataPaso3 = this.localStorageService.getPaso3();
    if (this.isPersonaNatural) {
      this.nombres = this.dataPaso3.persona.nombre.nombres + ' ' + this.dataPaso3.persona.nombre.apellidoPaterno;
      this.correo = this.dataPaso3.persona.correo;
    } else {
      this.nombres = this.dataPaso3.datosComercio.razonSocial;
      this.correo = this.localStorageService.getPaso1Login().correo;
    }
    
    this.riesgoso = this.dataPaso3.siguientePaso === null ? true : false;
    await this.productoService.cargaSeleccionActualEnCarro().toPromise();
    this.loading = false;
    this.tagM.logEvent(GoogleTagManager.eventPageView().confirmaCompra());
  }

}
